type CoachModelSettings = {
  coachModel: string;
  maxOutputTokens: number;
  temperature: number;
};

enum CoachTriggerType {
  EveryTurn = "everyTurn",
  Conditional = "conditional",
  LLMBased = "llmBased",
}

type CoachTrigger = {
  triggerType: CoachTriggerType;
  triggerConditions?: Array<string>;
  triggerPrompt?: string;
  minConversationTurns?: number;
};

type CoachKb = {
  enableKbSearch: boolean;
  knowledgeBaseIds: Array<string>;
  maxDocumnets: number;
};

enum CoachExecutionMode {
  Synchronous = "synchronous",
  Asynchronous = "asynchronous",
}

enum CoachExecutionFallbackBehavior {
  SkipCoach = "skipCoach",
  UseDefault = "useDefault",
}

type CoachExecution = {
  executionMode: CoachExecutionMode;
  timeoutMs: number;
  cacheResults: boolean;
  cacheTTLSeconds: number;
  fallbackBehavior: CoachExecutionFallbackBehavior;
};

enum CoachConversationScope {
  Recent = "recent",
  Full = "full",
}

type CoachContextSettings = {
  conversationScope: CoachConversationScope;
  recentMessagePairs: number;
};

type AssistantCoach = {
  coachEnabled: boolean;
  coachName: string;
  coachPrompt: string;

  modelSettings: CoachModelSettings;

  triggerSettings: CoachTrigger;

  kbSettings: CoachKb;

  executionSettings: CoachExecution;

  contextSettings?: CoachContextSettings;
};

export {
  AssistantCoach,
  CoachModelSettings,
  CoachTrigger,
  CoachKb,
  CoachExecution,
  CoachContextSettings,
  CoachConversationScope,
  CoachExecutionMode,
  CoachExecutionFallbackBehavior,
  CoachTriggerType,
};
